<script lang="ts">
  // A small "i" icon carrying exact-copy explainer text (see DESIGN's
  // tooltip copy list) — a native title attribute is the whole
  // implementation; no tooltip library needed for hover-only help text.
  import { Info } from 'lucide-svelte';
  const { text }: { text: string } = $props();
</script>

<span class="inline-flex translate-y-[1px] align-middle text-dark-gray" title={text} aria-label={text}>
  <Info class="h-3.5 w-3.5" />
</span>
